import { useIntl } from 'react-intl';
import { Table } from 'components/table';
import { StyledButton } from 'styles/overrides';
import { Link } from 'react-router-dom';
import { useSettings } from 'api/settingsApi';
import _ from 'lodash';
import { Publish } from 'components/common';
// import { Image } from 'antd';

export default function SettingTable() {
  const intl = useIntl();
  const { data, isLoading, isFetching } = useSettings();

  const columns = [
    {
      title: intl.formatMessage({ id: 'common.table.no' }),
      render: (text, record, index) => index + 1,
    },
    {
      title: intl.formatMessage({ id: 'views.settings.table.key' }),
      dataIndex: 'key',
    },
    // {
    //   title: intl.formatMessage({ id: 'views.settings.table.images' }),
    //   dataIndex: 'logo',
    //   render: (value) => <Image src={value?.path} size={32} />,
    // },
    {
      title: intl.formatMessage({ id: 'common.table.published' }),
      dataIndex: 'action',
      render: (value) => <Publish published={value} />,
    },
    {
      render: ({ key }) => (
        <Link to={`${key}`}>
          <StyledButton type="primary">
            {intl.formatMessage({ id: 'common.btn.seeDetails' })}
          </StyledButton>
        </Link>
      ),
    },
  ];

  return (
    <>
      <Table
        rowKey="id"
        columns={columns}
        dataSource={data || []}
        loading={isLoading || isFetching}
        pagination={false}
      />
    </>
  );
}
